/**
 * @file cart remove item
 *
 * Javascript documentation : http://usejsdoc.org/
 */

/**
 *
 * @type {{bindAll: Function, bindCartRemoveProduct: Function, trackRemoveFromCart: Function, trackUpdateCart: Function}}
 */
ACC.cartremoveitem = {

    bindAll: function () {
        this.bindCartRemoveProduct();
    },

    bindCartRemoveProduct: function (e) {
        // TODO: please DRY me!
        $('.submitRemoveProduct')
            .on("click", function (e) {
                e.preventDefault();
                /**
                 *
                 */
                var prodid = $(this).attr('id').split("_")[1];
                $('.ConfDelModal .modal-footer .ConfDelbtn').attr("entry-id", prodid);
                jQuery('.ConfDelModal').modal();
            });

        $('.updateQuantityProduct')
            .on(
            "click",
            function () {
                // fix for unique ids
                /**
                 *
                 * @type {*|jQuery}
                 */
                var prodid = $(this).attr('id').split("_")
                prodid = prodid[1];

                /**
                 *
                 */
                var productCode = $('#updateCartForm' + prodid).get(0).productCode.value;

                /**
                 *
                 */
                var initialCartQuantity = $('#updateCartForm' + prodid).get(0).initialQuantity.value;

                /**
                 *
                 */
                var newCartQuantity = $('#updateCartForm' + prodid).get(0).quantity.value;
                ACC.cartremoveitem.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);
                $('#updateCartForm' + prodid).get(0).submit();
            });
    },

    trackRemoveFromCart: function (productCode, initialCartQuantity) {
        window.mediator.publish('trackRemoveFromCart', {
            productCode: productCode,
            initialCartQuantity: initialCartQuantity
        });
    },

    trackUpdateCart: function (productCode, initialCartQuantity, newCartQuantity) {
        window.mediator.publish('trackUpdateCart', {
            productCode: productCode,
            initialCartQuantity: initialCartQuantity,
            newCartQuantity: newCartQuantity
        });
    }
};

$(document).ready(function () {
    ACC.cartremoveitem.bindAll();
});
